<!-- Toolbar -->
<mat-toolbar class="page-toolbar mat-elevation-z1 flex">
  <div>
    <!-- Page Title -->
    <ng-content></ng-content>

    <!-- Breadcrumb -->
    <ul class="bread-crumb">
      <li *ngFor="let breadcrumb of breadcrumbs$ | async">
        <span [routerLink]="breadcrumb.url">{{
          breadcrumb.label | translate
        }}</span>
      </li>
    </ul>
  </div>
</mat-toolbar>
